import React from "react";

import { Icon } from "../types";

const DownloadButton: React.FC<Icon> = ({ color, width, height, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 15"
    fill={color}
    {...props}
  >
    <path
      d="M0.167969 14.6667H11.8346V13H0.167969V14.6667ZM11.8346 5.5H8.5013V0.5H3.5013V5.5H0.167969L6.0013 11.3333L11.8346 5.5Z"
      fill={color}
    />
  </svg>
);
export default DownloadButton;
